import { notes } from "@phoenixreisen/mithrils/src/notification";
import { getLogins, saveLastLogins } from "../shared/functions";
import { logError } from "../../../shared/functions/misc";
import { Link } from "mithril/route";
import m from "mithril";
const RouteLink = Link;
const remove = (login, state, e) => {
    e?.preventDefault();
    try {
        const { lastLogins } = state;
        const filtered = lastLogins.filter((item) => {
            return item.rechnr !== login.rechnr;
        });
        saveLastLogins(filtered);
        state.lastLogins = filtered;
    }
    catch {
        notes.add({
            status: "error",
            text: "Login konnte nicht gelöscht werden",
        });
    }
    finally {
        m.redraw();
    }
};
const toggleImage = (state, route, e) => {
    e.preventDefault();
    state.routeImage = route;
};
const LastLogins = {
    oninit({ state }) {
        state.lastLogins = getLogins();
    },
    view({ state }) {
        const { lastLogins } = state;
        try {
            return (m("div", { class: "form last-logins" },
                m("h2", { class: "f4 mb2 pb0" }, "Ihre gespeicherten Anmeldungen"),
                m("p", null,
                    m("p", null, "Wenn Sie fr\u00FChere Anmeldungen gespeichert haben, werden diese hier angezeigt. So k\u00F6nnen Sie Ihre Buchung ausw\u00E4hlen und die Felder f\u00FCr Buchungsnummer und Nachname werden automatisch ausgef\u00FCllt. Sie m\u00FCssen dann nur noch Ihr Passwort eingeben.")),
                m("div", { class: "fadeIn animated fast" },
                    lastLogins.map((login) => {
                        const route = `/kunde/anmeldung/${login.rechnr}/${login.lastname}`;
                        return (m("div", { class: "login-ident" },
                            m("div", { class: "login-ident-icon", "aria-hidden": "true" }, login.route ? (m("button", { tabIndex: "-1", type: "button", class: "btn-route-image", onclick: (e) => toggleImage(state, login.route, e) },
                                m("img", { src: login.route }))) : (m("i", { class: "fas fa-ship" }))),
                            m(RouteLink, { RouteLink: true, href: route },
                                m("div", null,
                                    m("strong", null,
                                        login.rechnr,
                                        ", ",
                                        login.lastname)),
                                m("div", null,
                                    login.start,
                                    login.title ? ", " : "",
                                    login.title)),
                            m("button", { type: "button", class: "login-ident-delete btn btn--secondary", onclick: (e) => remove(login, state, e), title: `Gespeicherte Buchung ${login.rechnr}, ${login.lastname} entfernen` },
                                m("i", { class: "fas fa-times" }))));
                    }),
                    m(RouteLink, { href: "/kunde", class: "login-ident login-ident--other" },
                        m("span", null, "Mit einer anderen Buchung anmelden"),
                        m("i", { class: "fas fa-arrow-right ml2" }))),
                state.routeImage && (m("button", { type: "button", class: "login-ident-route-image", onclick: (e) => toggleImage(state, null, e), title: "Bild schlie\u00DFen" },
                    m("img", { src: state.routeImage, class: "bounceIn animated", role: "presentation" })))));
        }
        catch (e) {
            logError(e);
            m.route.set("/kunde");
        }
    },
};
export default LastLogins;
